export default __webpack_public_path__ + "static/media/Cloudxier-mainbanner.3a1d62d2.png";